export const EMAIL_SEPARATOR_REGEX = /[\n,\s]$/g;

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const NOT_ALPHA_NUM_REGEX = /[^\w]/g;
export const NOT_NUMS_REGEX = /[^\d]/g;
export const POSITIVE_NUMBER_REGEX = /^[0-9]+(\.{1}[0-9]{1,2})?/gi;

export const URL_REGEX =
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;

export const VALID_EMAIL_FILTER_REGEX =
  /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi;

export const VALID_DOMAIN_FILTER_REGEX = /^[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/;

export const NUMS_REGEX = /\d/g;

export const ALPHA_REGEX = /[a-z]/gi;

export const ALPHA_NUMERIC_SEARCH_REGEX = /^[a-zA-Z0-9\s]*$/;

export const PASSWORD_REGEX = /^(?!.*\s)(?=.*[A-Za-z])(?=.*?[#?!@\.$%^&*-])(?=.*?[0-9]).{8,}/;

export const DIGITS_PATTERN = "[0-9]*";

export const TWO_DIGIT_DECIMAL_OPTIONAL_PATTERN = /(0(\.\d{0,2})?)|\d*(\.\d{0,2})?/;

export const NON_WORK_EMAILS_REGEX =
  /^.*(gmail\.com|yahoo\.com|hotmail\.com|icloud\.com|outlook\.com)[a-z0-9]*$/;

export const DOT_REGEX = /\.{1}/gi;

export const NON_ALPHANUMERIC_REGEX = /[^a-z0-9]/gi;

export const VALID_CPF_TAX_REGEX =
  /^\d{3}\x2E\d{3}\x2E\d{3}\x2D\d{2}$|^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;

/* IMAGE UPLOAD DEFAULTS */
export const MAXIMUM_IMAGE_SIZE_MB = 5;
export const MAXIMUM_IMAGE_SIZE = MAXIMUM_IMAGE_SIZE_MB * 1024 * 1024;
export const acceptedImageFormats = ["jpeg", "jpg", "png"];
export const acceptedImageFormatsRegex = new RegExp(acceptedImageFormats.join("|"), "gi");
/* ****ENDS**** */
